export enum COMPETITION_ID {
  'IPAD_OKT_2024' = 'ipad_okt_2024',
}
